import {Locale} from '@hebcal/hdate';
import poData from './ashkenazi_poylish.po.js';
Locale.addLocale('ashkenazi_poylish', poData);
